(() => {
  const initializeCollectionPost = (section) => {
    if (!section || section.dataset.collectionPostReady === "true") return;

    section.dataset.collectionPostReady = "true";

    const content = section.querySelector("[data-collection-post-content]");
    const readMoreButton = section.querySelector("[data-collection-post-read-more]");
    const collapseHeight = Number(section.dataset.collapseHeight);
    const sectionInner = section.querySelector(".collection-post__inner");
    const legacyAccordionContainer = content?.querySelector(".accordion-container");

    if (sectionInner && legacyAccordionContainer) {
      sectionInner.append(legacyAccordionContainer);
    }

    if (content && readMoreButton && Number.isFinite(collapseHeight)) {
      const updateCollapsedState = () => {
        const expanded = readMoreButton.getAttribute("aria-expanded") === "true";
        if (expanded) return;

        content.classList.remove("is-collapsed");
        const needsCollapse = content.scrollHeight > collapseHeight;
        content.classList.toggle("is-collapsed", needsCollapse);
        readMoreButton.hidden = !needsCollapse;
      };

      readMoreButton.addEventListener("click", () => {
        const willExpand = readMoreButton.getAttribute("aria-expanded") !== "true";

        readMoreButton.setAttribute("aria-expanded", String(willExpand));
        content.classList.toggle("is-collapsed", !willExpand);
        readMoreButton.textContent = willExpand
          ? readMoreButton.dataset.lessLabel
          : readMoreButton.dataset.moreLabel;
      });

      updateCollapsedState();

      if ("ResizeObserver" in window) {
        const observer = new ResizeObserver(updateCollapsedState);
        observer.observe(section);
      }
    }

    const legacyAccordionButtons = section.querySelectorAll(".accordion button");

    legacyAccordionButtons.forEach((accordionButton) => {
      if (!accordionButton.hasAttribute("aria-expanded")) {
        accordionButton.setAttribute("aria-expanded", "false");
      }

      accordionButton.addEventListener("click", () => {
        const willExpand = accordionButton.getAttribute("aria-expanded") !== "true";

        legacyAccordionButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });

        accordionButton.setAttribute("aria-expanded", String(willExpand));
      });
    });
  };

  const initializeWithin = (root) => {
    if (root.matches?.("[data-collection-post]")) {
      initializeCollectionPost(root);
    }

    root.querySelectorAll?.("[data-collection-post]").forEach(initializeCollectionPost);
  };

  initializeWithin(document);

  document.addEventListener("shopify:section:load", (event) => {
    initializeWithin(event.target);
  });
})();
